import { useTranslation } from 'next-i18next'

import { Link } from '~/components/Link'
import ROUTES from '~/shared/constants/routes.const'

export function TermsAndConditions({
  className = '',
  linkClassName,
}: {
  className?: string
  linkClassName?: string
}): React.ReactElement {
  const { t } = useTranslation('registerAccount')
  return (
    <div className={`mx-auto pt-6 text-center text-xxs font-medium ${className}`}>
      <span>{t('byContinuingYouAgreeToOur')}</span>{' '}
      <Link className={`hover:underline ${linkClassName}`} openInNewTab to={ROUTES.PRIVACY}>
        {t('privacyPolicy')}
      </Link>{' '}
      <span>{t('and')}</span>{' '}
      <Link className={`hover:underline ${linkClassName}`} openInNewTab to={ROUTES.TERMS}>
        {t('termsAndConditions')}
      </Link>
      .
    </div>
  )
}
